module.exports = __webpack_public_path__ + "img/icon-24-ic-open-in-new-tab-blue.0861e6c7.svg";